<template>
  <div>
    <div class="form">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="费率：" prop="rate">
          <el-input v-model="form.rate"></el-input>
        </el-form-item>
        <el-form-item label="保证期：" prop="logo">
          <el-radio-group v-model="form.logo">
            <el-radio label="0">三个月</el-radio>
            <el-radio label="1">半年</el-radio>
            <el-radio label="2">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分期付款：">
          <el-radio-group v-model="form.installment">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="期数：" v-if="form.installment == 0">
          <div class="by_stages">
            <el-input v-model="form.periods" class="input"></el-input>
            <div class="expect">期</div>
            <div class="later">入职后</div>
            <el-input v-model="form.entryLate" class="input" @change="changeEntryLate"></el-input>
            <div class="past_due">过保证期</div>
            <el-input
              v-model="form.guaranteePeriodLate"
              class="input"
              @change="changeGuaranteePeriodLate"
            ></el-input>
            <el-input
              class="inputCompileAdd"
              v-model="item.value"
              v-for="(item, index) in inputCompileAddList"
              :key="index"
              @change="threeLate"
            ></el-input>
            <div class="compileAdd" @click="clickOption">编辑</div>
          </div>
        </el-form-item>
        <el-form-item label="招聘潜力：">
          <el-radio-group v-model="form.recruitPotential">
            <el-radio label="1">1分</el-radio>
            <el-radio label="2">2分</el-radio>
            <el-radio label="3">3分</el-radio>
            <el-radio label="4">4分</el-radio>
            <el-radio label="5">5分</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="确认需求：">
          <el-input v-model="form.confirmDemand"></el-input>
        </el-form-item>
        <el-form-item label="潜在需求：">
          <el-input v-model="form.concealDemand"></el-input>
        </el-form-item>
        <el-form-item label="链接方：" prop="linkSideId">
          <el-select v-model="form.linkSideId" filterable placeholder="请选择链接方">
            <el-option
              v-for="item in linkSideList"
              :key="item.id"
              :label="item.linkSideName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同：">
          <uploadFile
            :fileList.sync="form.contracts"
            @fileAddr="fileAddr"
            @fileLook="fileLook"
            @removeUrl="removeUrl"
          ></uploadFile>
        </el-form-item>
      </el-form>
      <div class="save_key">
        <div class="save_key_button" @click="accomplish">保存</div>
        <div class="retreat" @click="clickReverseBack">返回上级</div>
      </div>
    </div>
  </div>
</template>
<script>
import uploadFile from '../components/uploadFile.vue'
import { selectContract, saveContract, getLinksParty } from '@/api/businessCenter.js'
export default {
  components: { uploadFile },
  data() {
    //这里存放数据
    return {
      form: {
        clueCode: '', // 线索编号
        concealDemand: '', // 潜在需求（人数）
        confirmDemand: '', // 确定需求（人数）
        contract: null, // 合同  字符串
        contracts: [], // 合同  数组
        createName: '',
        createTime: '',
        entryLate: '50%', // 入期后百分比（分期付款为是,与保证期百分比和为1）
        guaranteePeriodLate: '50%', // 保证期后百分比（分期付款为是）
        id: null,
        installment: '', // 分期付款0->是；1->否
        linkSideId: '', // 链接方id
        logo: '', // 保证期0->3个月；1->半年；2->其他
        periods: '2', // 期数
        rate: '', // 费率
        recruitPotential: '', // 招聘潜力：1分，2分，3分，4分，5分
        updateName: '',
        updateTime: '',
        threeLate: '' // 第三期百分比
      },
      rules: {
        rate: [{ required: true, message: '请输入费率', trigger: 'blur' }],
        logo: [{ required: true, message: '请选择保证期', trigger: 'blur' }],
        linkSideId: [{ required: true, message: '请选择链接方', trigger: 'blur' }]
      },
      row: {},
      // 链接方list
      linkSideList: [],
      contractList: [],
      inputCompileAddList: []
    }
  },

  computed: {},

  watch: {},
  created() {
    let row1 = sessionStorage.getItem('row1')
    if (row1) {
      this.row = JSON.parse(row1)
    } else {
      this.row = JSON.parse(this.$route.query.row)
    }
    this.getLinksPartyData()
    this.getSelectContract()
    // console.log(this.row)
  },
  methods: {
    // 根据code查询id
    async getSelectContract() {
      const { data: res } = await selectContract({
        clueCode: JSON.parse(sessionStorage.getItem('row1')).clueCode
      })
      if (res.resultCode == 200) {
        this.form = res.data
        if (this.form.threeLate != '' && this.form.threeLate != null) {
          this.inputCompileAddList.push({
            value: this.form.threeLate
          })
        }
        if (res.data.contracts == null) {
          this.form.contracts = []
        }
        if (this.form.contracts.length != 0) {
          let con = []
          this.form.contracts.forEach((item) => {
            // con.push(item)
            con.push(item)
          })
          this.contractList = [...con]
          // this.form.contracts = con
        }
      }
      // console.log(res, 'res')
    },
    // 第三期百分比输入
    threeLate() {
      // console.log(this.inputCompileAddList)
      if (!this.inputCompileAddList[0].value.includes('%')) {
        this.inputCompileAddList[0].value = this.inputCompileAddList[0].value + '%'
      }
    },
    // 编辑
    clickOption() {
      if (this.inputCompileAddList.length == 1) {
        return this.$message('最多支持三期')
      }
      this.form.periods = 3
      this.inputCompileAddList.push({
        value: ''
      })
      // console.log(this.inputCompileAddList, 'inputCompileAddList')
    },
    async getLinksPartyData() {
      const { data: res } = await getLinksParty({
        baseParam: {
          pageNum: 1,
          pageSize: 100
        },
        clueCode: this.row.clueCode,
        id: null,
        order: 'desc',
        orderType: '0'
      })
      if (res.resultCode == 200) {
        this.linkSideList = res.data.list
      }
      // console.log(this.linkSideList)
    },
    // 合同  短路径
    fileAddr(val) {
      console.log(val)
    },
    // 合同 长路径
    fileLook(val) {
      this.contractList.push(val)
      // console.log(this.contractList)
    },
    // 移除
    removeUrl(file) {
      // console.log(file.url)
      // console.log(file)
      // console.log(this.contractList)
      this.contractList.forEach((item, index) => {
        if (item.uid) {
          if (item.uid == file.uid) {
            this.contractList.splice(index, 1)
          } else if (item.url == file.url) {
            this.contractList.splice(index, 1)
          }
        } else {
          if (item == file.url) {
            // console.log(1)
            this.contractList.splice(index, 1)
          }
        }
      })
      // console.log(this.contractList)
    },
    // 点击返回上一级
    clickReverseBack() {
      this.$router.go(-1)
    },
    // 保存
    accomplish() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.form.clueCode = JSON.parse(sessionStorage.getItem('row1')).clueCode
          if (this.form.installment == 0 && this.form.periods == 3) {
            this.form.threeLate = this.inputCompileAddList[0].value
          }
          if (this.contractList.length != 0) {
            this.form.contracts = []
            this.contractList.forEach((item) => {
              if (item.url) {
                this.form.contracts.push(item.url)
              } else {
                this.form.contracts.push(item)
              }
            })
          } else if (this.contractList.length == 0) {
            this.form.contracts = []
          }
          this.form.contract = null
          const { data: res } = await saveContract(this.form)
          if (res.resultCode == 200) {
            this.$message.success('线索签约成功！')
            this.$router.push({
              path: '/businessCenter/clueCenter'
            })
          }
        }
      })
    },
    // 入职后
    changeEntryLate() {
      if (!this.form.entryLate.includes('%')) {
        this.form.entryLate = this.form.entryLate + '%'
      }
      if (this.form.periods == 2) {
        let entryLate = this.form.entryLate // 入职后
        let sum = 100 //  1
        this.form.guaranteePeriodLate = sum - Number(entryLate.replace('%', '')) + '%' // 赋值
      }
    },
    // 过保证期
    changeGuaranteePeriodLate() {
      if (!this.form.guaranteePeriodLate.includes('%')) {
        this.form.guaranteePeriodLate = this.form.guaranteePeriodLate + '%'
      }
    }
  },

  mounted() {}
}
</script>
<style scoped lang="less">
.form {
  background-color: #fff;
  padding-top: 43px;

  /deep/.el-input {
    width: 258px;
  }
  /deep/.el-form-item {
    margin-bottom: 16px;
  }
  .by_stages {
    display: flex;
    color: #333;
    font-size: 14px;
    .expect {
      margin-right: 24px;
      margin-left: 5px;
    }
    .later {
      margin-right: 9px;
    }
    .past_due {
      margin: 0 7px 0 44px;
    }
    .inputCompileAdd {
      margin-left: 20px;
      // margin-right: 7px;
      width: 75px;
      height: 24px;
    }
    .compileAdd {
      cursor: pointer;
      color: #17757a;
      margin-left: 17px;
    }

    .input {
      width: 50px;
    }
    /deep/.el-input__inner {
      height: 24px;
      line-height: 24px;
      padding: 0;
      text-align: center;
    }
  }
}
.save_key {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  .save_key_button {
    width: 126px;
    height: 32px;
    background-color: #17757a;
    border-radius: 4px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
  }
  .retreat {
    width: 126px;
    height: 32px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #17757a;
    color: #17757a;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 21px;
    cursor: pointer;
    font-size: 14px;
  }
}
</style>
